import {Film} from "@/modules/Rhizome/interfaces/film.interface";
import anime from 'animejs/lib/anime.es.js';
import {bus} from "@/plugins/bus";
import {isEdgeOrFirefox} from "@/plugins/browser-detection";

export class AnimationJsService {
  drawingLines = false;

  private arrayFilms: Film.IFilmCloud[] = [];

  constructor(arrayFilms: Film.IFilmCloud[]) {
    this.arrayFilms = arrayFilms;
  }

  public moveToStartPosition() {
    this.drawingLines = false;
    this.arrayFilms.forEach(film => this.returnOnStartPosition(film));
  }

  private returnOnStartPosition(film) {
    if (film.refDomElement.offsetLeft !== film.originalPosition.x || film.refDomElement.offsetTop !== film.originalPosition.y ) {
      let x = film.originalPosition.x;
      let y = film.originalPosition.y;
      film.refDomElement.style.transform = `translate(${x}px, ${y}px)`;
    }
  }

  public moveFromActive(film: Film.IFilm) {
    let activeFilm = this.arrayFilms.find(currentFilm => currentFilm.id === film.id);
    let config = this.getCoordsConfig(activeFilm);

    // Calculate coords of animated elements.
    const interval = 400;
    let startPositionX = activeFilm.originalCenter.x - interval;
    let endPositionX = activeFilm.originalCenter.x + interval;
    let startPositionY = activeFilm.originalCenter.y - interval;
    let endPositionY = activeFilm.originalCenter.y + interval;

    this.arrayFilms.forEach((currentFilm, index) => {
      let connectedFilm = film.connectionWith?.find(line => line.id === currentFilm.id);
      // Move only those elements that are included in a special radius.
      if ((currentFilm.originalCenter.x <= startPositionX || currentFilm.originalCenter.x >= endPositionX ||
          currentFilm.originalCenter.y <= startPositionY || currentFilm.originalCenter.y >= endPositionY) &&
         !connectedFilm?.id) {
        this.returnOnStartPosition(currentFilm);
        return;
      }

      // anime.remove(currentFilm.refDomElement);
      if (currentFilm.id !== activeFilm.id) {
        // anime.remove(currentFilm.refDomElement.querySelector('.wrapper'));
        let finishCoords = this.getPositionElement(currentFilm, config);
        currentFilm.refDomElement.style.transform = `translate(${finishCoords.x}px, ${finishCoords.y}px)`;
        // this.startBrowningMovement(currentFilm);
      }
      else {
        let timer = 0;
        this.drawingLines = true;
        let interval = setInterval(() => {
          if (timer < 8 && this.drawingLines) {
            bus.$emit('redrawLines', activeFilm);
            timer++;
          }
          else {
            this.drawingLines = false;
            clearInterval(interval);
          }
        }, 200);
        anime.remove(currentFilm.refDomElement.querySelector('.wrapper'));
        currentFilm.refDomElement.style.transform = `translate(${activeFilm.originalCenter.x}px, ${activeFilm.originalCenter.y}px)`;
      }
    });
  }

  private getCoordsConfig(activeFilm) {
    let config = {
      centerPoint: {
        x: activeFilm.originalCenter.x,
        y: activeFilm.originalCenter.y,
      },
      rightSideX: activeFilm.activeSidesCoords.rightX,
      leftSideX: activeFilm.activeSidesCoords.leftX,
      topSideY: activeFilm.activeSidesCoords.topY,
      bottomSideY: activeFilm.activeSidesCoords.bottomY,
      minDiv: activeFilm.scaledSize.width * 0.25,
    };

    return config;
  }

  private getPositionElement(currentFilm, config) {
    let startX = currentFilm.originalPosition.x;
    let startY = currentFilm.originalPosition.y;

    let koefX = 1;
    let koefY = 1;

    // first quarter
    if (startX >= config.centerPoint.x && startY <= config.centerPoint.y) {
      koefX = Math.min(startX, config.rightSideX) / Math.max(startX, config.rightSideX);
      koefY = Math.min(startY, config.topSideY) / Math.max(startY, config.topSideY);
    }
    // second quarter
    if (startX < config.centerPoint.x && startY <= config.centerPoint.y) {
      koefX = Math.min(startX, config.leftSideX) / Math.max(startX, config.leftSideX);
      koefY = Math.min(startY, config.topSideY) / Math.max(startY, config.topSideY);
    }
    // third quarter
    if (startX < config.centerPoint.x && startY > config.centerPoint.y) {
      koefX = Math.min(startX, config.leftSideX) / Math.max(startX, config.leftSideX);
      koefY = Math.min(startY, config.bottomSideY) / Math.max(startY, config.bottomSideY);

    }
    // fours quarter
    if (startX >= config.centerPoint.x && startY > config.centerPoint.y) {
      koefX = Math.min(startX, config.rightSideX) / Math.max(startX, config.rightSideX);
      koefY = Math.min(startY, config.bottomSideY) / Math.max(startY, config.bottomSideY);
    }

    let quarterKoefX = startX >= config.centerPoint.x ? 1 : -1;
    let quarterKoefY = startY >= config.centerPoint.y ? 1 : -1;

    let finishX = startX + quarterKoefX * config.minDiv * koefY;
    let finishY = startY + quarterKoefY * config.minDiv * koefX;

    return {
      x: finishX += this.randomInteger(-25, 25),
      y: finishY += this.randomInteger(-25, 25)
    }
  }

  private randomInteger(min: number, max: number) {
    let rand = min + Math.random() * (max + 1 - min);
    return Math.floor(rand);
  }

  public startBrowningMovement(movedElement: any, loop: boolean = false, interval: number = 5) {
    // if (isEdgeOrFirefox()) return;

    anime({
      targets: movedElement.refDomElement.querySelector('.wrapper'),
      keyframes: [
        { translateX: this.randomInteger(-interval, interval),  translateY: this.randomInteger(-interval, interval) },
        { translateX: this.randomInteger(-interval, interval),  translateY: this.randomInteger(-interval, interval) },
        { translateX: 0,  translateY: 0 },
      ],
      duration: this.randomInteger(3000, 5000),
      delay: this.randomInteger(200, 1000),
      easing: 'linear',
      loop: loop
    });
  }
}
